// project import
import Routes from "routes";
import ThemeCustomization from "themes";
import Locales from "components/Locales";
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";

// auth-provider
import { JWTProvider as AuthProvider } from "contexts/JWTContext";
import { HandlerProvider } from "contexts/HelperContext";

import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
const queryClient = new QueryClient();

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <HandlerProvider>
              <Notistack>
                <Routes />
                <Snackbar />
              </Notistack>
            </HandlerProvider>
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
    <ToastContainer />
  </QueryClientProvider>
);

export default App;
